import React from 'react';

export const CollapsableAnd: React.VFC = () => (
  <React.Fragment>
    <span className="visible-xs-inline">& </span>
    <span className="hidden-xs">and </span>
  </React.Fragment>
);
